import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast_config } from "../../utils/constants";
import { toast } from "react-toastify";
const BASE_URL = process.env.REACT_APP_BASE_URL;

export const UserRegister = createAsyncThunk(
  "UserRegister",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/api/v1/User/register-user`,
        arg
      );
      toast.success(
        "OTP sent successfully. Please check your email.",
        toast_config
      );
      return response;
    } catch (error) {
      toast.error(error.response?.data?.message, toast_config);
      return rejectWithValue(error);
    }
  }
);

export const VendorRegister = createAsyncThunk(
  "VendorRegister", // Corrected action name to "VendorRegister"
  async (arg, { rejectWithValue }) => {
    console.log("-----arg---------", arg);
    try {
      const response = await axios.post(
        `${BASE_URL}/api/v1/User/register-vendor`,
        arg
      );
      toast.success(
        "OTP sent successfully. Please check your email.",
        toast_config
      );

      return response;
    } catch (error) {
      console.log("-----error---------", error);
      toast.error(error.response?.data?.message, toast_config);
      return rejectWithValue(error);
    }
  }
);

export const co_ordinatorRegister = createAsyncThunk(
  "co_ordinatorRegister", 
  async (arg, { rejectWithValue }) => {
    console.log("-----arg---------", arg);
    try {
      const response = await axios.post(
        `${BASE_URL}/api/v1/User/register-CO-ORDINATOR`,
        arg
      );
      console.log("-----response---------", response); 
      toast.success("Coordinator registered successfully", toast_config);
      window.location.reload();
      return response;
    } catch (error) {
      console.log("-----error---------", error);
      toast.error(error.response?.data?.message, toast_config);
      return rejectWithValue(error);
    }
  }
);

export const deleteUser = createAsyncThunk(
  "deleteUser",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `${BASE_URL}/api/v1/User/delete-user`,
        { data: { id } }
      );
      toast.success("User deleted successfully", toast_config);
      return response;
    } catch (error) {
      toast.error(error.response?.data?.message, toast_config);
      return rejectWithValue(error);
    }
  }
);

// export const UpdateUser = createAsyncThunk(
//   "UpdateUser",
//   async (FormData, { rejectWithValue }) => {
//     try {
//       const response = await axios.put(
//         `${BASE_URL}/api/v1/User/Update-usersInfo`,
//         FormData
//       );
//       toast.success("Update successfully", toast_config);
//       return response;
//     } catch (error) {
//       toast.error(error.response?.data?.message, toast_config);
//       return rejectWithValue(error);
//     }
//   }
// );

export const UpdateUser = createAsyncThunk(
  "UpdateUser",
  async (FormData, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `${BASE_URL}/api/v1/User/Update-usersInfo`,
        FormData
      );
      toast.success("Update successfully", toast_config);
      return response;
    } catch (error) {
      toast.error(error.response?.data?.message, toast_config);
      return rejectWithValue(error);
    }
  }
);

export const fetchCounts = createAsyncThunk(
  "dashboard/fetchCounts",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/api/v1/User/all-user`);
      return response.data;
    } catch (error) {
      toast.error(error.response?.data?.message, toast_config);
      return rejectWithValue(error);
    }
  }
);

export const ShowAllUsers = createAsyncThunk(
  "ShowAllUsers",
  async (arg, { rejectWithValue }) => {
    console.log("-----arg---------", arg);
    try {
      const response = await axios.get(
        `${BASE_URL}/api/v1/User/ShowAll-users`,
        arg
      );
      console.log("-----response---------", response);

      return response.data.data;
    } catch (error) {
      console.log("-----error---------", error);
      toast.error(error.response?.data?.message, toast_config);
      return rejectWithValue(error);
    }
  }
);

export const ShowAllVendors = createAsyncThunk(
  "ShowAllVendors",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/api/v1/User/ShowAll-users?role=vendor`
      );
      return response.data.data; // Adjust based on API response structure
    } catch (error) {
      toast.error(error.response?.data?.message, toast_config);
      return rejectWithValue(error);
    }
  }
);

export const ShowAllCoordinators = createAsyncThunk(
  "ShowAllCoordinators",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/api/v1/User/ShowAll-users?role=co-ordinator`
      );
      return response.data.data; // Adjust based on API response structure
    } catch (error) {
      toast.error(error.response?.data?.message, toast_config);
      return rejectWithValue(error);
    }
  }
);

export const ShowUsersInfo = createAsyncThunk(
  "ShowUsersInfo",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/api/v1/User/Show-usersInfo/${id}`
      );
      console.log("-----response---------", response);

      return response.data;
    } catch (error) {
      console.log("-----error---------", error);
      // toast.error(error.response?.data?.message, toast_config);
      return rejectWithValue(error);
    }
  }
);

const RegisterSlice = createSlice({
  name: "registerSlice",
  initialState: {
    counts: { userCount: 0, vendorCount: 0, coordinatorCount: 0 },
    userData: [],
    AlluserData: [],
    vendors: [],
    coordinators: [],
    IsAdding: false,
    loading: false,
    error: null,
  },
  reducers: {
    IsAddingOpen: (state, action) => {
      state.IsAdding = true;
    },
    IsAddingClose: (state, action) => {
      state.IsAdding = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(UserRegister.pending, (state) => {
        state.loading = true;
      })
      .addCase(UserRegister.fulfilled, (state, action) => {
        state.loading = false;
        console.log(`-------UserRegister action---------`, action);
      })
      .addCase(UserRegister.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      })
      .addCase(VendorRegister.pending, (state) => {
        state.loading = true;
      })
      .addCase(VendorRegister.fulfilled, (state, action) => {
        state.loading = false;
        console.log(`-------VendorRegister action---------`, action);
      })
      .addCase(VendorRegister.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      })
      .addCase(ShowAllVendors.pending, (state) => {
        state.loading = true;
      })
      .addCase(ShowAllVendors.fulfilled, (state, action) => {
        state.loading = false;
        state.vendors = action.payload;
      })
      .addCase(ShowAllVendors.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      })
      .addCase(ShowAllCoordinators.pending, (state) => {
        state.loading = true;
      })
      .addCase(ShowAllCoordinators.fulfilled, (state, action) => {
        state.loading = false;
        
        state.coordinators = action.payload;
      })
      .addCase(ShowAllCoordinators.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      })
      .addCase(co_ordinatorRegister.pending, (state) => {
        state.loading = true;
      })
      .addCase(co_ordinatorRegister.fulfilled, (state, action) => {
        state.loading = false;
        console.log(`-------co_ordinatorRegister action---------`, action);
      })
      .addCase(co_ordinatorRegister.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      })
      .addCase(ShowAllUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(ShowAllUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.AlluserData = action.payload.AllUsers;
      })
      .addCase(ShowAllUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      })
      .addCase(ShowUsersInfo.pending, (state) => {
        state.loading = true;
      })
      .addCase(ShowUsersInfo.fulfilled, (state, action) => {
        state.loading = false;
        state.AlluserData = action.payload.userdetail;
      })
      .addCase(ShowUsersInfo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      })
      .addCase(deleteUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      })
      .addCase(UpdateUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpdateUser.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(UpdateUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      })
      .addCase(fetchCounts.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCounts.fulfilled, (state, action) => {
        state.loading = false;
        state.counts = action.payload;
      })
      .addCase(fetchCounts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      });
  },
});

export const { IsAddingOpen, IsAddingClose } = RegisterSlice.actions;
export default RegisterSlice.reducer;
